import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import  PropTypes from 'prop-types';
import moment from 'moment';
import { Divider, Row, Col } from "antd";
import {
    SectionSpacing,
    GhostButtonComponent,
    SummaryLabel,
    SummaryData,
    DataHeading,
    DisplayFlex,
    PrimaryButtonComponent
} from '../../../../../../CommonComponents/commonStyles';
import Breadcrumb from "../../../../../../CommonComponents/Breadcrumb/Breadcrumb";
import { RecommendAnExchangeHeading, Heading, SectionHeading, HrDivider, NavigationButtonGroup } from '../../styles';
import Context from '../../context';
import { NavigationBtnContainer } from '../../styles';
import ExchangeOptions from '../exchangeOptions';
import { FlexContainer } from '../exchangeReview/styles';

//import { calTotalAmount } from '../../util';
import EditButton from '../editButton';
import FromTable from '../exchangeReview/FromTable';
import ToTable from '../exchangeReview/ToTable';
import { getPrimaryAccount } from '../../../../../../utils/sessionUtil';
import { todayDate, initiateTracking, recordError } from '../../../../../../utils/commonUtil';
import Preloader from '../../../../../../CommonComponents/Preloader/Preloader';
import BreadcrumbComponent from '../../../../../../CommonComponents/Breadcrumb/Breadcrumb';
import 'moment-timezone';

const breadcrumbRoutes = [
    {
        routeName: 'Home',
        path: '/',
    },
    {
        routeName: 'Investments',
        path: '/investments',
    },
    {
        routeName: 'Exchange Activity',
        path: '/investments/exchange-activity',
    },
    {
        routeName: 'View and Edit Exchange',
        path: '/investments/recommend-an-exchange/:id/view',
    },
];

const ViewSpawn = (props) => {
    const { exchangeDetails = {}, history, handleBack, isLoading, edit, id, exchPendingSpawnId, location, isNew } = props; // id is exchange id or schedule id
    const { exchangeContext } = useContext(Context);
    const { from, to } = exchangeContext;
    const viewAllExchanges = () => {
        try {
            history.push('/investments/exchange-activity');
        } catch (error) {
          recordError(error);
        }
    }
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    if (isLoading) return <Preloader />
    return (
        <>
            <BreadcrumbComponent breadcrumbRoutes={breadcrumbRoutes} />
            <SectionSpacing>
                <Row>
                    <Col xs={12} md={24}>
                        <SummaryLabel>{exchangeDetails.fundName}</SummaryLabel>
                    </Col>
                    <Col xs={12} md={24}>
                        <SummaryData>{getPrimaryAccount().accountNumber}</SummaryData>
                    </Col>
                </Row>
            </SectionSpacing>
            <FlexContainer>
                <SectionSpacing>
                    <DisplayFlex>
                        <DataHeading>Entered Date: </DataHeading>
                        <Heading className="ml-10">{moment(moment.tz(exchangeDetails.enteredDate, 'America/New_York')).format('MM/DD/YYYY')}</Heading>
                    </DisplayFlex>
                    <DisplayFlex>
                        <DataHeading>Status:</DataHeading>
                        <Heading className="ml-10">{exchangeDetails.status}</Heading>
                    </DisplayFlex>
                </SectionSpacing>
                <HrDivider />
                <SectionSpacing>
                    <DisplayFlex>
                        <DataHeading>Received date & time: </DataHeading>
                        <Heading className="ml-10">
                            {exchangeDetails.receivedDate ? <>{moment(moment.tz(exchangeDetails.receivedDate, 'America/New_York')).format('MM/DD/YYYY [at] HH:mm A' )} </> : <>&mdash;</>}
                        </Heading>
                    </DisplayFlex>
                    <DisplayFlex>
                        <DataHeading>{exchangeDetails.status === 'Completed' ? 'Trade Date:' : 'Estimated trade date:'} </DataHeading>
                        <Heading className="ml-10">{exchangeDetails.tradeDate ? moment(moment.tz(exchangeDetails.tradeDate, 'America/New_York')).format('MM/DD/YYYY') : <>&mdash;</> }</Heading>
                    </DisplayFlex>
                </SectionSpacing>
            </FlexContainer>
            <Divider className="m0" />
            <SectionSpacing>
                <Row>
                    <ExchangeOptions
                        scheduleType={from.scheduleType}
                        exchangeType={from.exchangeType}
                        edit={edit}
                        history={history}
                        id={id}
                        location={location}
                        status={exchangeDetails.status}
                        tradeDate={<>&mdash;</>}
                        isNew={isNew}
                        isViewEdit={true}
                    />
                </Row>
            </SectionSpacing>
            <Divider className="m0" />
            <SectionSpacing>
                <FlexContainer>
                    <SectionHeading>Recommend exchange from</SectionHeading>
                    <EditButton onClick={(e) => {
                        try {
                            let params = queryString.parse(location.search);
                            params = params ? { ...params, edit: true } : { edit: true }
                            initiateTracking('edit', 'View and Edit Recurring Exchange Spawn', 'Recommend exchange from', `Edit`);
                            history.push({
                                pathname: `/investments/recommend-an-exchange/${id}/spawn/${exchPendingSpawnId}/from`,
                                search: queryString.stringify(params)
                            });
                        } catch (error) {
                          recordError(error);
                        }
                    }} />
                </FlexContainer>
                <Row>
                    <Col xs={24} lg={12}>
                        <FromTable dataSource={from.pools} allocationType={from.allocationType} isConfirmation="true" />
                    </Col>
                </Row>
            </SectionSpacing>
            <Divider className="m0" />
            <SectionSpacing>
                <FlexContainer>
                    <SectionHeading>Recommend exchange to</SectionHeading>
                    <EditButton onClick={(e) => {
                        try {
                            let params = queryString.parse(location.search);
                            params = params ? { ...params, edit: true } : { edit: true }
                            initiateTracking('edit', 'View and Edit Recurring Exchange Spawn', 'Recommend exchange to', `Edit`);
                            history.push({
                                pathname: `/investments/recommend-an-exchange/${id}/spawn/${exchPendingSpawnId}/to`,
                                search: queryString.stringify(params)
                            });
                        } catch (error) {
                            recordError(error);
                        }
                    }} />
                </FlexContainer>
                <Row>
                    <Col xs={24} lg={12}>
                        <ToTable dataSource={to.pools} isReview={false} isLegacy={exchangeDetails.legacy} />
                    </Col>
                </Row>
            </SectionSpacing>
            <SectionSpacing>
                <NavigationButtonGroup>
                    <PrimaryButtonComponent className="sm-btn-w100" primary onClick={viewAllExchanges}>
                        Back to Exchange Activity
                    </PrimaryButtonComponent>
                    <PrimaryButtonComponent className="sm-btn-w100" primary
                        onClick={() => {
                            try {
                                initiateTracking('back2', 'View and Edit Recurring Exchange Spawn', '', `Back to the Schedule`);
                                history.push({
                                    pathname: `/investments/recommend-an-exchange/${id}/view`,
                                    search: 'type=recurring'
                                })
                            } catch (error) {
                              recordError(error);
                            }
                        }}>
                        Back to the schedule
                    </PrimaryButtonComponent>
                </NavigationButtonGroup>
            </SectionSpacing>
        </>
    );
};

ViewSpawn.propTypes = {
    userId: PropTypes.string,
    handleExit: PropTypes.func,
    exchangeDetails: PropTypes.string,
    spawnsLoading: PropTypes.bool,
    handleBack: PropTypes.func,
    getInitialData: PropTypes.func,
    edit: PropTypes.bool,
    isDirty: PropTypes.bool,
    id: PropTypes.string,
    isLoading: PropTypes.bool,
    refreshExchangeDetails: PropTypes.func,
    isNew: PropTypes.bool,
    isBalanceZero: PropTypes.bool,
  }


export default withRouter(ViewSpawn);